import { Directive, ElementRef } from '@angular/core';

// Used for sliders to obtain references to projected children.
@Directive({
  selector: '[v2SliderChild]'
})
export class V2SliderChildDirective {
  constructor(public hostElement: ElementRef) {}
}
